module.exports = __webpack_public_path__ + "static/media/carouselRight.817820d1.svg";